import { IconButton } from '@chakra-ui/react';
import { MdNotificationsNone } from 'react-icons/md';

interface NotificationsBellProps {}

const NotificationsBell: React.FC<NotificationsBellProps> = () => {
  function onClick() {}

  return (
    <div>
      <IconButton
        variant="ghost"
        aria-label="notifications"
        icon={<MdNotificationsNone style={{ fontSize: 26, color: '#C2C6CB' }} />}
        onClick={onClick}
      />
    </div>
  );
};

export default NotificationsBell;
